import { hasTerm } from './helpers';
import { FDealType, FOfferType, NonEmptyArray, IJsonQuery, ExtractOptionalKeys } from './types';
import { dealTypeFromJsonQuery, offerTypeFromJsonQuery } from './utils';

export type TAvailabilityFunction = (jsonQuery: IJsonQuery) => boolean;

export function isAvailable(dealType: FDealType, offerType: FOfferType): TAvailabilityFunction {
  return jsonQuery => {
    const nextDealType = dealTypeFromJsonQuery(jsonQuery);
    const nextOfferType = offerTypeFromJsonQuery(jsonQuery);

    return (dealType & nextDealType) !== 0 && (offerType & nextOfferType) !== 0;
  };
}

export function isAvailableStrict(dealType: FDealType, offerType: FOfferType): TAvailabilityFunction {
  return jsonQuery => {
    const nextDealType = dealTypeFromJsonQuery(jsonQuery);
    const nextOfferType = offerTypeFromJsonQuery(jsonQuery);

    return nextDealType === dealType && nextOfferType === offerType;
  };
}

export function isAvailableIfKeysUnset(keys: NonEmptyArray<ExtractOptionalKeys<IJsonQuery>>): TAvailabilityFunction {
  return jsonQuery => {
    return !keys.some(k => hasTerm(k)(jsonQuery));
  };
}

export function oneOf(
  ...functions: [TAvailabilityFunction, TAvailabilityFunction, ...TAvailabilityFunction[]]
): TAvailabilityFunction {
  return jsonQuery => {
    return functions.some(f => f(jsonQuery));
  };
}

export function everyOf(
  ...functions: [TAvailabilityFunction, TAvailabilityFunction, ...TAvailabilityFunction[]]
): TAvailabilityFunction {
  return jsonQuery => {
    return functions.every(f => f(jsonQuery));
  };
}
